import { styled } from "@mui/material/styles";
const HeaderMain = styled("div")(({ theme }) => ({
  background: "#E3E3E3",
  width: "100%",
  height: "50px",
  padding: "5px 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  position: "relative",
}));
const SelectAccountMain = styled("div")(({ theme }) => ({
  width: "19%",
  position: "relative",
  "& .css-1707uvj-container .css-1s1upiv-control": {
    marginBottom: "0px",
    height: "42px",
    borderRadius: "4px",
    border: "1px solid #858585",
  },
  "& .css-1707uvj-container .css-1s79at0-control": {
    marginBottom: "0px",
    height: "42px",
    borderRadius: "4px",
    border: "1px solid #858585",
  },
}));

export { HeaderMain, SelectAccountMain };
